import { Component, model, output, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Issue } from 'app/classes/issue';
import { APIService } from 'app/shared/api.service';
import { AssetService } from 'app/shared/asset.service';
import { BuildingsService } from 'app/shared/buildings.service';
import { IIssueTrackingComment, IssueTrackingCommentType, IssueTrackingService } from 'app/shared/issue-tracking.service';
import { WindowService } from 'app/shared/window.service';

@Component({
  selector: 'app-issue-tracking-comments',
  standalone: false,
  templateUrl: './issue-tracking-comments.component.html',
  styleUrl: './issue-tracking-comments.component.css'
})
export class IssueTrackingCommentsComponent {
  issue = model.required<Issue>();
  comment = '';
  commentType: IssueTrackingCommentType = null;
  dialog = signal<DialogType>(null);
  isImportant = signal(false);
  onUpated = output<boolean>();
  isMobile = false;
  isAddingComment = false;
  constructor(private buildingReviewService: BuildingsService, private issueTracking: IssueTrackingService, private assetService: AssetService, private apiService: APIService, private route: ActivatedRoute, private windowService: WindowService) {

    this.isMobile = this.windowService.isMobile();
  }

  addComment() {
    // Stop double click duplicates.
    if (this.isAddingComment) return;
    this.comment = this.comment?.trim();
    if (this.comment.length < 1) {
      this.dialog.set(null);
      return;
    }
    this.isAddingComment = true;
    this.apiService.toastSuccess('Adding comment...', null, 900);
    this.issueTracking.addComment(this.issue().id, this.comment, this.commentType, { isImportant: this.isImportant() }).then(response => {
      this.apiService.toastSuccess('Comment has been added', null, 500);
      this.dialog.set(null);
      this.onUpated.emit(true);
      this.isAddingComment = false;
    });
  }

  deleteComment(comment: IIssueTrackingComment) {
    this.apiService.toastSuccess('Marking comment as deleted...', null, 1000);
    this.issueTracking.deleteComment(comment.id, comment.comment).then(d => {
      this.onUpated.emit(true);
    });
  }

  setPriority(isSet: boolean) {
    this.isImportant.set(isSet);
  }
}

export type DialogType = 'new-comment';
